// extracted by css-extract-rspack-plugin
export default {"title":"NYJ4Nc"};